<template>
    <page>
        <module :title="verify ? '社区内容审核' : '社区内容详情'">
            <div v-if="baseInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="审核状态" >{{stateText[baseInfo.state]}}</c-detail-item>
                    <c-detail-item label="发布时间" >{{baseInfo.create_date}}</c-detail-item>
                    <c-detail-item label="社区类型" >
                          {{momentsTypeMap[baseInfo.moments_type]}}
                    </c-detail-item>
                    <c-detail-item label="社区标题" >{{baseInfo.title}}</c-detail-item>
                    <c-detail-item label="是否推荐" >
                        <span v-if="baseInfo.is_recommend == 0" style="color: darkgray">不推荐</span>
                        <span v-if="baseInfo.is_recommend == 1" style="color: green">推荐</span>
                    </c-detail-item>
                    <c-detail-item label="是否隐藏" >
                        <span v-if="baseInfo.is_valid == 0" style="color: red">隐藏</span>
                        <span v-if="baseInfo.is_valid == 1" style="color: green">显示</span>
                    </c-detail-item>
                    <c-detail-item label="发布内容" full>
                        {{baseInfo.content}}
                    </c-detail-item>
                </c-detail>


                <c-detail v-if="mediaList.length != 0" title="媒体文件">
                    <c-detail-item label="图片/视频" full>
                        <div class="img-list flex-wrap">
                        <div v-for="(item, j) in mediaList" :key="j" style="margin-right: 10px;">
                          <c-image class="img" :src="item.file_url" size="120" preview></c-image>
                        </div>
                        </div>
                    </c-detail-item>


                </c-detail>

            </div>

            <template v-if="verify" slot="button">
                <c-button power="b_moments_apply_apply" size="m" @click="verifyHandle(1)">审核显示</c-button>
                <c-button power="b_moments_apply_apply" size="m" color="red"  @click="verifyHandle(0)">审核隐藏</c-button>
            </template>
        </module>

        <c-dialog ref="approvalReason" :title="showFlag ? '审核显示':'审核隐藏'" width="450" @resolve="approvalHandle">
            <c-form ref="editForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="hidden" name="is_valid"></c-form-item>
                <c-form-item type="select" label="所属模块" name="classify" required options="CLASSIFY_SHARE"></c-form-item>
                <c-form-item v-if="showFlag" type="radio" label="是否推荐" name="is_recommend" v-model="isRecommend" :options="recommendOptions"></c-form-item>
                <c-form-item v-if="showFlag" type="radio" label="是否优质帖" name="high_quality" v-model="highQuality" :options="highQualityOptions"
                             word="优质帖将额外奖励积分"></c-form-item>
            </c-form>
        </c-dialog>

    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'coupon_task_detail',

        props: {
            id: String,

            verify: Boolean
        },

        data() {
            return {
                state: [ {
                    name: '未审核',
                    value: 1
                }, {
                    name: '已审核',
                    value: 2
                }],
                isRecommend:0,
                recommendOptions: [
                    {name: '不推荐',value: 0},
                    {name: '推荐',value: 1}
                ],
                highQuality:0,
                highQualityOptions: [
                    {name: '非优质',value: 0},
                    {name: '优质',value: 1}
                ],
                showFlag: false,
                momentsTypeMap: {'1':'日记','2':'问答','3':'话题','4':'探店视频','5':'分享'},
                recommendMap: {'1':'是','0':'否'},
                validMap: {'1':'是','0':'否'},
                baseInfo: '',
                mediaList: [],
				error_code: 404
            }
        },

        computed: {
            ...mapState(['dict']),
            stateText() {
                var state = {};
                this.state.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        watch: {
            id() {
                this.getTaskDetail();
            }
        },

        mounted() {
            this.getTaskDetail();
        },

        methods: {
            getTaskDetail() {
                this.request({
                    url: '/moments_apply/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.baseInfo = data;
                        this.mediaList = data.media_list || [];
                    }
                });
            },

            verifyHandle(state) {
                this.$refs.editForm.clear();
                if(state == '1'){
                    this.$refs.editForm.set({id:this.baseInfo.id,is_valid:1});
                    this.showFlag = true;
                    this.$refs.approvalReason.open();
                }else{
                    this.$confirm({
                        text: '确定要审核隐藏该数据吗？',  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                            this.request({
                                url: '/moments_apply/edit_apply_state',
                                data: {
                                    id: this.baseInfo.id,
                                    is_valid: 0,
									is_flag: 0
                                },
                                loading: true,
                                success: (data, message) => {
                                    this.$message({
                                        text: '操作成功',
                                        icon: 'success'
                                    });
                                    this.$bus.$emit('momentsApplyList.update');
                                    this.redirectTo('/moments_apply');
                                },
								fail: (code, data, message) => {
									this.error_code = code;
									var title ="审核失败";
									var cancel_flag = false;
									if(this.error_code == 999){
										title = '二次确认';
										cancel_flag = true;
									}
									this.$confirm({
										title: title,
									    text: message,  // 提示内容,
									    buttonName: '确定',  // 确定按钮文字
										icon: 'success',
										cancelButton: cancel_flag,  // 是否显示取消按钮
										resolve: () => {
											if(this.error_code == 999){
												this.request({
												    url: '/moments_apply/edit_apply_state',
												    data: {
												        id: this.baseInfo.id,
												        is_valid: 0,
														is_flag: 1
												    },
												    loading: true,
												    success: (data, message) => {
												        this.$message({
												            text: '操作成功',
												            icon: 'success'
												        });
												        this.$bus.$emit('momentsApplyList.update');
												        this.redirectTo('/moments_apply');
												    }
												});
											}
										}  // 确定按钮回调
									});
									return false;
								}
                            });
                        },  // 确定按钮回调
                        cancel: () => {},  // 取消按钮回调
                    });

                }

            },
            approvalHandle(stop){
                stop();
                this.$refs.editForm.submit({
                    url: '/moments_apply/edit_apply_state',
                    rule: {
                        id: '无参数id',
                        is_valid: '无参数显示状态',
                        classify: '请选择社区数据归属的模块',
                        /*classify:[{
                            type:'empty',
                            skip: () => {
                                return this.baseInfo.moments_type != 5;
                            },
                            word: '请选择当前分享归属的模块'
                        }]*/
                    },
                    dataFormatter: data => {
						data.is_flag = 0;
                        return data;
                    },
                    success: (data,obj) => {
                        this.$message({
                            text: '操作成功'
                        });
                        this.$bus.$emit('momentsApplyList.update');
                        this.redirectTo('/moments_apply');
                    },
					fail: (code, data, message) => {
						this.error_code = code;
						var title ="审核失败";
						var cancel_flag = false;
						if(this.error_code == 999){
							title = '二次确认';
							cancel_flag = true;
						}
						this.$confirm({
							title: title,
							text: message,  // 提示内容,
							buttonName: '确定',  // 确定按钮文字
							icon: 'success',
							cancelButton: cancel_flag,  // 是否显示取消按钮
							resolve: () => {
								if(this.error_code == 999){
									this.$refs.editForm.submit({
									    url: '/moments_apply/edit_apply_state',
									    dataFormatter: data => {
											data.is_flag = 1;
									        return data;
									    },
									    success: (data,obj) => {
									        this.$message({
									            text: '操作成功'
									        });
									        this.$bus.$emit('momentsApplyList.update');
									        this.redirectTo('/moments_apply');
									    }
									})
								}
							}  // 确定按钮回调
						});
						return false;
					}
                })
            },
        }
    }
</script>

<style lang="stylus" scoped>
	.img-check {
		margin-top: 12px;
		font-size 13px;
		text-align: center;
		
		.icon {
			margin-right: 5px;
			font-size: 15px;
		}
		
		.tips {
			margin-left: 5px;
			font-size: 15px;
		}
	}
</style>